import { getCountryCode } from '@utils/getCountryCode';

export type Country = {
  id: string;
  shortCode: string;
  countryName: string;
  RequireState: boolean;
};

export type AccPhone = {
  phoneType: string | null;
  number: string | null;
  countryId: string | null;
  extension: string | null;
};

export default (
  phone: AccPhone,
  countries?: Pick<
    Country,
    'id' | 'countryName' | 'shortCode' | 'RequireState'
  >[]
) => {
  const country = countries?.find(country => country.id === phone.countryId);
  const countryPhoneCode = getCountryCode(country?.shortCode);

  return `${countryPhoneCode && `+${countryPhoneCode}`} ${phone.number}`;
};
